import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BioPagePublic from "./BioPagePublic";
import Redirector from "./Redirector";
import { api } from "../lib/api";
import { isMarketingHost, isShortHost } from "../config/origins";

/**
 * PublicResolver — the apex catch-all (`/:code`) serves two different things
 * depending on host:
 *   - marketing host (linklane.io)  → a bio page  (handle = bio slug, beacons-style)
 *   - short host     (lny.me)       → a short link (handle = code)
 * Short links and bios never share a host, so there's no collision in prod.
 *
 * In dev / preview the split is inert (single origin), so we can't tell by host —
 * probe the bio API for the handle and fall back to the short-link resolver.
 */
export default function PublicResolver() {
  const { code } = useParams();
  if (isShortHost()) return <Redirector />;
  if (isMarketingHost()) return <BioPagePublic />;
  return <DevResolver key={code} handle={code} />;
}

function DevResolver({ handle }) {
  const [mode, setMode] = useState("loading");
  useEffect(() => {
    let alive = true;
    api
      .get(`/bio/${handle}`)
      .then(() => alive && setMode("bio"))
      .catch(() => alive && setMode("short"));
    return () => {
      alive = false;
    };
  }, [handle]);
  if (mode === "loading") return null;
  return mode === "bio" ? <BioPagePublic /> : <Redirector />;
}
